/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type BulkUpdateSafetyStockDto = {
    /**
     * New safety stock value
     */
    safetyStock: number;
    /**
     * Update scope
     */
    scope: BulkUpdateSafetyStockDto.scope;
    /**
     * Location ID (required when scope=location)
     */
    locationId?: number;
    /**
     * Category ID for product type (required when scope=productType)
     */
    categoryId?: number;
    /**
     * Product IDs (required when scope=productIds)
     */
    productIds?: Array<number>;
};
export namespace BulkUpdateSafetyStockDto {
    /**
     * Update scope
     */
    export enum scope {
        ALL = 'all',
        LOCATION = 'location',
        PRODUCT_TYPE = 'productType',
        PRODUCT_IDS = 'productIds',
    }
}

